import React from 'react';
type SectionHeadingProps = {
  id: string;
  children: React.ReactNode;
  className?: string;
};
export function SectionHeading({
  id,
  children,
  className = ''
}: SectionHeadingProps) {
  return <div className={`text-center ${className}`} data-id="element-209" data-mp="vytka0m3k6hk">
      <h2 id={id} className="mx-auto max-w-3xl text-balance font-display text-4xl font-extrabold uppercase leading-[1.05] tracking-tight text-foreground sm:text-5xl" data-id="element-210" data-mp="vxjo5gyt18dk">
        {children}
      </h2>
      <span className="mx-auto mt-4 flex w-fit items-center gap-1" aria-hidden="true" data-id="element-211" data-mp="mzzizwxtmrxo">
        <span className="h-1 w-10 rounded-full bg-accent" data-id="element-212" data-mp="i6dh8zt748gn" />
        <span className="glow-line h-1 w-3 rounded-full bg-highlight" data-id="element-213" data-mp="d8bxsdruy74n" />
      </span>
    </div>;
}